<template>
	<div class="home" :class="{ 'gray': gray }">
		<el-carousel style="width: 100%;">
			<el-carousel-item v-for="item in bannerList" :key="item.id">
				<div class="img_bg" :style="`background: url(${item.lunimage}) no-repeat center`"></div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { getBannerList } from '@/utils/api.js'
import {
	mapState,
	mapMutations
} from 'vuex'
export default {
	name: 'Home',
	data() {
		return {
			bannerList: [],
			// gray: false,    // 首页是否置灰
		}
	},
	computed: mapState(['gray']),
	created() {
		this.getBannerList()
	},
	methods: {
		...mapMutations(['SETGRAY']),
		
		async getBannerList() {
			const res = await getBannerList()
			if (res.code == 200) {
				this.bannerList = res.content
			}
		}
	}
}
</script>

<style>
/* 首页置灰 */
.gray {
	-webkit-filter: grayscale(100%);
	filter: grayscale(100%);
}

.el-carousel .el-carousel__container {
	height: 53.5rem;
}

.img_bg {
	width: 100%;
	height: 53.5rem;
	/* background: url(../assets/bg1.png) no-repeat center; */
	background-size: cover;
	/* padding-top: 4.65625rem; */

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

}

@media screen and (max-width:480px) {
	.el-carousel .el-carousel__container {
		height: 12.25rem;
		background-size: cover;
	}

	.img_bg {
		height: 12.25rem;
		background-size: cover !important;
	}
}
</style>
